import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from "@air/primitive-switch";
import { useAirModal } from "@air/provider-modal";
import { useCallback } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { contentCollectionApplyAllSelector, contentCollectionTouchedSelector, setApplyAllAction, setTouchedAction } from "../redux";
import { ContentCollectionApplyAllModal } from "./ContentCollectionApplyAllModal";
import { ContentCollectionCustomFieldsList } from "./ContentCollectionCustomFieldList";
export const ContentCollectionSidebarCustomFields = (param)=>{
    let { renderCustomField } = param;
    const dispatch = useDispatch();
    const store = useStore();
    const applyAll = useSelector(contentCollectionApplyAllSelector);
    const [showApplyAllModal, hideApplyAllModal] = useAirModal(ContentCollectionApplyAllModal);
    const onCheckedChange = useCallback((checked)=>{
        const touched = contentCollectionTouchedSelector(store.getState());
        if (checked && touched) {
            showApplyAllModal({
                onApplyAll: ()=>{
                    dispatch(setApplyAllAction({
                        applyAll: checked
                    }));
                    dispatch(setTouchedAction({
                        touched: false
                    }));
                    hideApplyAllModal();
                }
            });
        } else {
            dispatch(setApplyAllAction({
                applyAll: checked
            }));
        }
    }, [
        dispatch,
        hideApplyAllModal,
        showApplyAllModal,
        store
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-14 font-semibold text-grey-11",
                children: "Apply any required fields to all items before submitting."
            }),
            /*#__PURE__*/ _jsxs("label", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Switch, {
                        checked: applyAll,
                        onCheckedChange: onCheckedChange
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-14 font-semibold text-grey-11",
                        children: "Apply to all items"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ContentCollectionCustomFieldsList, {
                className: "gap-6",
                renderCustomField: (param)=>{
                    let { customField } = param;
                    return renderCustomField({
                        customField,
                        disabled: !applyAll
                    });
                }
            })
        ]
    });
};
